import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Box, Divider, Typography } from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  FacebookAuthProvider,
} from "firebase/auth";
import { useAuth } from "../../context/AuthContext";
import api from "../../services/api";

function SocialSignInButtons() {
  const auth = getAuth();
  const location = useLocation();
  const returnTo = location.state?.returnTo || "/";
  const navigate = useNavigate();
  const { handleLogin } = useAuth();

  const handleGoogleSignIn = async () => {
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({ prompt: "select_account" });

    try {
      const result = await signInWithPopup(auth, provider);
      const firebaseUser = result.user;

      // 🔁 Force-refresh the ID token
      const firebaseToken = await firebaseUser.getIdToken(true);

      const authResponse = await api.post(
        `/auth/social-signup`,
        {},
        {
          headers: { Authorization: `Bearer ${firebaseToken}` },
        }
      );

      if (authResponse?.data) {
        // wait a short moment to allow state to catch up
        setTimeout(() => {
          handleLogin(); // this will trigger fetchUserDetails using correct user
          navigate(returnTo);
        }, 500);
      }
    } catch (error) {
      console.error("Google sign-in failed", error);
    }
  };

  const handleFacebookSignIn = async () => {
    const provider = new FacebookAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const firebaseUser = result.user;
      const firebaseToken = await firebaseUser.getIdToken();

      const authResponse = await api.post(
        `/auth/social-signup`,
        {},
        {
          headers: { Authorization: `Bearer ${firebaseToken}` },
        }
      );

      if (authResponse?.data) {
        await handleLogin();
        navigate(returnTo);
      }
    } catch (error) {
      console.error("Facebook sign-in failed", error);
    }
  };

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 3, mb: 3 }}>
      <Divider sx={{ my: 1, position: "relative", textAlign: "center" }}>
        <Typography
          variant="body2"
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            px: 1,
          }}>
          OR
        </Typography>
      </Divider>

      {/* Uncomment if you plan to use Facebook in the future */}
      {/* <Button
        variant="contained"
        startIcon={<FacebookIcon />}
        sx={{
          backgroundColor: "#1877F2",
          color: "#fff",
          textTransform: "none",
          fontWeight: "bold",
          justifyContent: "center",
          px: 3,
          "&:hover": {
            backgroundColor: "#145DB2",
          },
        }}
        onClick={handleFacebookSignIn}
      >
        Continue with Facebook
      </Button> */}

      <Button
        variant="outlined"
        startIcon={<GoogleIcon />}
        sx={{
          textTransform: "none",
          fontWeight: "bold",
          justifyContent: "center",
          px: 3,
          borderColor: "#ddd",
          color: "#333",
          "&:hover": {
            backgroundColor: "#f9f9f9",
          },
        }}
        onClick={handleGoogleSignIn}>
        Continue with Google
      </Button>
    </Box>
  );
}

export default SocialSignInButtons;
